if (!customElements.get('product-story')) {
  customElements.define('product-story', class extends HTMLElement {
    connectedCallback() {
      this.imageStrip = this.querySelector('[data-story-images]');
      this.onImageKeydown = (event) => {
        if (!['ArrowLeft', 'ArrowRight'].includes(event.key) || this.imageStrip.scrollWidth <= this.imageStrip.clientWidth) return;
        event.preventDefault();
        this.moveImage(event.key === 'ArrowRight' ? 1 : -1);
      };
      this.imageStrip.addEventListener('keydown', this.onImageKeydown);
      this.onPreviousImage = () => this.moveImage(-1);
      this.onNextImage = () => this.moveImage(1);
      this.querySelector('[data-story-prev]').addEventListener('click', this.onPreviousImage);
      this.querySelector('[data-story-next]').addEventListener('click', this.onNextImage);
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribeVariant = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const variant = event.data?.variant;
          if (!variant) return;
          this.showVariant(variant.id);
        });
      }
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!reduceMotion && 'IntersectionObserver' in window) {
        this.observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-revealed');
              this.observer.unobserve(entry.target);
            }
          });
        }, { threshold: 0.08 });
        this.querySelectorAll('.app-pdp-benefit, .app-pdp-technical, .app-pdp-practical').forEach((card) => {
          card.classList.add('has-reveal');
          this.observer.observe(card);
        });
      }
    }
    showVariant(id) {
      const source = this.querySelector(`template[data-story-variant="${id}"]`);
      const destination = this.querySelector('[data-story-images]');
      if (!source || !destination || String(id) === this.dataset.selectedVariant) return;
      destination.replaceChildren(source.content.cloneNode(true));
      const label = this.querySelector('[data-story-variant-label]');
      if (label) label.textContent = source.dataset.variantLabel;
      this.dataset.selectedVariant = String(id);
      destination.scrollTo({left:0,behavior:'instant'});
    }
    moveImage(direction) {
      const gap = parseFloat(getComputedStyle(this.imageStrip).columnGap) || 0;
      const step = this.imageStrip.clientWidth + gap;
      const count = this.imageStrip.querySelectorAll('.app-pdp-story__photo').length;
      if (count < 2) return;
      const index = (Math.round(this.imageStrip.scrollLeft / step) + direction + count) % count;
      this.imageStrip.scrollTo({left:index * step,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    }
    disconnectedCallback() {
      this.unsubscribeVariant?.();
      this.observer?.disconnect();
      this.imageStrip?.removeEventListener('keydown', this.onImageKeydown);
      this.querySelector('[data-story-prev]')?.removeEventListener('click', this.onPreviousImage);
      this.querySelector('[data-story-next]')?.removeEventListener('click', this.onNextImage);
    }
  });
}
